import React from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import { EditLoanerPenalty } from './EditLoanerPenalty'
import { DeletePenaltyAmount } from './DeletePenaltyAmount'
import {  useSelector } from 'react-redux'
import { RootState } from '../../state/reducer'
import {PenaltyAmount} from "../../api";



interface PenaltyDataGridProps {
  results: PenaltyAmount[]
  page_size: number
  current: number
  count: number
  onFilter: (filters: any) => void
  handleTableChange: (type: string, state: any) => void
  children?: React.ReactNode
  hiddenRowKeys?: string[]
  onError?: (error: any) => void
  getData: () => void
  onDelete: (item: PenaltyAmount) => void
}



export const PenaltyDataGrid: React.FC<PenaltyDataGridProps> = ({
  results,
  page_size,
  current,
  count,
  onFilter,
  handleTableChange,
  children,
  hiddenRowKeys,
  onError,
  getData,
  onDelete,
}) => {
  const { user } = useSelector((state: RootState) => state.auth)
  const { role, is_superuser } = user || {}
  const { rights } = useSelector((state: RootState) => state.userRights)

  const actionFormatter = (
    cell: any,
    row: PenaltyAmount,
    rowIndex: number,
    formatExtraData?: any
  ) => {


    const canDelete =
      user && (role === 'SuperUser' || is_superuser || role === 'Privileged')

    return (
      <ReactBootstrap.Dropdown>
        <ReactBootstrap.Dropdown.Toggle variant="dark" size="sm" />
        <ReactBootstrap.Dropdown.Menu>
          <EditLoanerPenalty
            title="Edit Loaner Inventory Entry"
            onSubmit={getData}
            onError={onError}
            item={row}
          />
          {canDelete && (
            <DeletePenaltyAmount
              onDelete={onDelete}
              item={row}
            />
          )}

        </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>
    )
  }

  const columns = [
    {
      dataField: 'part_number',
      text: 'Part Number',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'reason',
      text: 'Reason',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'cost',
      text: 'Cost',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'created_at',
      text: 'Created On',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'date',
    },
    {
      dataField: '',
      text: '',
      isDummyField: true,
      formatter: actionFormatter,
    },
  ]

  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>Loaner Penalties</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-white text-end" xs={6}>
            <components.Slider
              sliderWidth="20vw"
              size="sm"
              title={components.ICONS.SEARCH}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-3"> Loaner Penalty</span>
                </span>
              }
            >
              <components.GenericSearchForm onFilter={onFilter} columns={columns} />
            </components.Slider>
            {children}
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <components.DataGrid
          keyField="url"
          data={results || []}
          sizePerPage={page_size}
          current={current}
          columns={columns}
          page={current}
          count={count}
          onTableChange={handleTableChange}
          hiddenRows={hiddenRowKeys}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
